// chatWindows.js — Petit bus pub/sub pour ouvrir une fenêtre de chat DM FLOTTANTE depuis n'importe où
// (languette « Amis en ligne », « Mes messages », carte profil…) SANS naviguer vers l'espace membre.
// Le gestionnaire <ChatDock/> (monté app-wide) écoute et gère l'empilement (max 3 desktop / 1 mobile).
const listeners = new Set();

// user attendu : { user_id|id, username, display_name, avatar_url }
export function openChatWindow(user) {
  if (!user) return;
  const uid = user.user_id || user.id;
  if (!uid) return;
  const target = { id: uid, user_id: uid, username: user.username, display_name: user.display_name, avatar_url: user.avatar_url };
  listeners.forEach((fn) => { try { fn(target); } catch { /* noop */ } });
}

export function onOpenChatWindow(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
